
























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';


@Component
export default class IpWithFrequentEvents extends mixins<PlanLimitsMixin>(PlanLimitsMixin) {
  @Prop() conditions: any;
  value: string = 'IP_NOT_WITH_FREQUENT_EVENTS';
  predicate: string = 'EQUALS';

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any) {
    if(!value.ipWithFrequentEvents) {
      this.$set(this.conditions, 'ipWithFrequentEvents', {
        predicate: 'EQUALS',
        values: 'IP_NOT_WITH_FREQUENT_EVENTS'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string) {
    this.$set(this.conditions.ipWithFrequentEvents, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string) {
    this.$set(this.conditions.ipWithFrequentEvents, 'predicate', value);
  }

  mounted() {
    this.value = this.conditions.ipWithFrequentEvents.values;
  }

}
